import React, { useContext, useEffect } from 'react';
import { Context } from '../../hooks/Store';
import "./c82_corsi_e_master_cards.scss";
import DoubleTemplateComponent from "../../containers/template_page/double_template_component/double_template_component";
import { API_CONFIG } from "../../config/api_config";
import axios from "axios";
import { isMobileOnly } from "react-device-detect";


const CorsiEMasterCard = (props) => {
    const [state, dispatch] = useContext(Context); // eslint-disable-line

    useEffect(() => {
        fetchData();
    }, []); // eslint-disable-line

    const fetchData = async () => {
        try {
            const epCategory = `${API_CONFIG.BASE_URL}/terms/${props.lang}/dipartimento`;
            axios.get(epCategory).then(response => {
                let terms = response.data.terms.sort((a, b) => (a.label > b.label) ? 1 : -1);
                terms.unshift({ 'label': 'All', 'id': '' });
                dispatch({ type: 'c81Dipartimento', payload: terms });
                dispatch({ type: 'c82CardsData', payload: props.data.items });
                dispatch({ type: 'c81CardEndpoint', payload: props.data.__data });
                dispatch({ type: 'c82NextCardsEndpoint', payload: props.data.next_page });
            })
        } catch (error) {
            console.log(error);
        }
    }

    const showMore = async () => {
        axios.get(state.cardLinkNextPage, {}).then(response => {
            dispatch({ type: 'c82NextCardsEndpoint', payload: response.data.next_page });
            dispatch({ type: 'c82CardsData', payload: state.dataC82.concat(response.data.items) });
        });
    };

    return <div id="corsiemastercards" className="container-fluid">
        {!isMobileOnly ?
            //desktop section
            <div className="row">
                {state.dataC82.length > 0 ? state.dataC82.map((course, index) =>
                    <a href={course.url} key={index} className="no-style"><div className="card" style={{ borderTopColor: course.color }}>
                        <div className="img-container" style={{ backgroundColor: course.color }}>
                            {course.card_image ? <img className="image-card" src={course.card_image} alt="Luiss.it" /> : null}
                        </div>
                        <div className="card-body">
                            <div className="title">{course.title}
                                <span className="flag-on-title">{course.flag ? <img src={`/${course.flag}.svg`} alt={course.flag} /> : null}</span>
                            </div>
                            <div className="category">{course.category}</div>
                            <div className="major-props overlay" style={{ background: course.color }} />
                            <div className="major-props majors">
                                <div className="list-group list-group-flush">
                                    <span className="flag-on-title-hover">{course.flag ?
                                        <img src={`/${course.flag}.svg`} alt={course.flag} /> : null}</span>
                                    <div className="title-hover">{course.title} </div>
                                    <div className="category-hover">{course.category}</div>
                                    {course.majors ? <hr /> : <br></br>}
                                    <div className="container-list-group">
                                        {course.majors ? course.majors.map((object, index) =>
                                            <div key={index} className="list-group-item">
                                                {object.title}
                                                <span className="flag-on-listgroup">
                                                    {object.flag ? <img src={`/${object.flag}.svg`} alt={object.flag} className="flag" /> : null}
                                                </span>
                                            </div>) : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div></a>
                ) : <div className={'row not-found mt-5'}>{props.lang === 'it' ? "Non ci sono corsi disponibili" : "No available courses"}</div>}
            </div> :
            //mobile section
            <div className="row justify-content-center margin-remover">
                {state.dataC82.length > 0 ? state.dataC82.map((course, index) =>
                    <div key={index} className="card-mob" style={{ borderTopColor: course.color }}>
                        <div className="img-container" style={{ backgroundColor: course.color }}>
                            {course.card_image ? <img className="image-card" src={course.card_image} alt="Luiss.it" /> : null}
                        </div>
                        <div className="card-body">
                            <a href={course.url} key={index} className="no-style">
                                <div className="title">{course.title}
                                    <span className="flag-on-title">{course.flag ? <img src={`/${course.flag}.svg`} alt={course.flag} /> : null}</span>
                                </div>
                            </a>
                            <div className="category">{course.category}</div>
                            {course.majors ? <hr /> : <br></br>}
                            <div className="container-list-group">
                                {course.majors ? course.majors.map((object, index) =>
                                    <div key={index} className="list-group-item">
                                        {object.title}
                                        <span className="flag-on-listgroup">
                                            {object.flag ? <img src={`/${object.flag}.svg`} alt={object.flag} className="flag" /> : null}
                                        </span>
                                    </div>) : null}
                            </div>
                        </div>
                    </div>
                ) : <div className={'row not-found mt-5'}>{props.lang === 'it' ? "Non ci sono corsi disponibili" : "No available courses"}</div>}
            </div>}
        <div className="container">
            <div className="row">
                <div className="col-12 text-center">
                    {state.cardLinkNextPage !== "" &&
                        <button className="carica-altro-btn" onClick={showMore}>{props.lang === 'it' ? "Carica Altro" : "Load More"}</button>
                    }
                </div>
            </div>
        </div>
    </div>;
};

class C82CorsiEMasterCards extends DoubleTemplateComponent {

    componentRender(allData) {
        return (
            <CorsiEMasterCard data={allData} lang={this.props.language} />
        )
    }
}

export default C82CorsiEMasterCards;
